import { newGetList, newPost, put, post, getOne, getList } from '../helper/baseFetch'
import { API_PATH } from '../Constants/path'

/**
 * Survey API Service
 * Centralized API calls with consistent error handling
 */

export const surveyService = {
  // ==================== Survey CRUD ====================

  /**
   * Fetch survey list with filters, pagination, and sorting
   */
  fetchList: async (params, store) => {
    return new Promise((resolve, reject) => {
      newGetList({
        path: API_PATH.survey.base,
        queryObj: params,
        successCallback: (payload) => resolve(payload),
        errorCallback: (error) => reject(error),
        store,
      })
    })
  },

  /**
   * Fetch survey detail by ID
   */
  fetchDetail: async (id, store) => {
    return new Promise((resolve, reject) => {
      getOne(
        `${API_PATH.survey.detail}/${id}`,
        undefined,
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Create new survey
   */
  create: async (data, store) => {
    return new Promise((resolve, reject) => {
      post(
        API_PATH.survey.base,
        data,
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Update survey
   */
  update: async (id, data, store) => {
    return new Promise((resolve, reject) => {
      put(
        `${API_PATH.survey.detail}/${id}`,
        data,
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Clone survey from existing survey
   */
  clone: async (sourceId, store) => {
    return new Promise((resolve, reject) => {
      newPost({
        path: API_PATH.survey.clone,
        body: { sourceId },
        successCallback: (payload) => resolve(payload),
        errorCallback: (error) => reject(error),
        store,
      })
    })
  },

  /**
   * Toggle survey status (Active/Pause/Delete)
   */
  toggleStatus: async (id, status, store) => {
    return new Promise((resolve, reject) => {
      put(
        `${API_PATH.survey.status}/${id}`,
        { status },
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Delete survey (soft delete by setting status to 'D')
   */
  delete: async (id, store) => {
    return surveyService.toggleStatus(id, 'D', store)
  },

  /**
   * Enable survey (set status to 'A')
   */
  enable: async (id, store) => {
    return surveyService.toggleStatus(id, 'A', store)
  },

  /**
   * Disable survey (set status to 'P')
   */
  disable: async (id, store) => {
    return surveyService.toggleStatus(id, 'P', store)
  },

  // ==================== Survey Mapping CRUD ====================

  /**
   * Fetch survey mapping list
   */
  fetchMappingList: async (params, store) => {
    return new Promise((resolve, reject) => {
      getList(
        API_PATH.surveyMapping.base,
        params,
        (payload) => resolve(payload),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Fetch survey mapping detail by ID
   */
  fetchMappingDetail: async (id, store) => {
    return new Promise((resolve, reject) => {
      getOne(
        `${API_PATH.surveyMapping.base}/${id}`,
        undefined,
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Create survey mapping
   */
  createMapping: async (data, store) => {
    return new Promise((resolve, reject) => {
      post(
        API_PATH.surveyMapping.base,
        data,
        (result) => resolve(result),
        // (error) => reject(error),
        null,
        store
      )
    })
  },

  /**
   * Update survey mapping
   */
  updateMapping: async (id, data, store) => {
    return new Promise((resolve, reject) => {
      put(
        `${API_PATH.surveyMapping.base}/${id}`,
        data,
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },

  /**
   * Update survey mapping status (Active/Pause/Delete)
   */
  updateMappingStatus: async (id, status, store) => {
    return new Promise((resolve, reject) => {
      put(
        `${API_PATH.surveyMapping.status}/${id}`,
        { status },
        (result) => resolve(result),
        (error) => reject(error),
        store
      )
    })
  },
}

/**
 * Extract list length from API response
 * Used by fetchList hook
 */
export const extractListLength = (response) => {
  return response?.count || 0
}
